<template>
  <div>
    <div class="row">
      <div class="col-md-10"></div>
      <div class="col-md-2"></div>
    </div>
    <div class="col-md-12">
      <h4>Editar Grupo</h4>
    </div>
    <div class="col-md-12">
      <div class="row">
        
        <div class="col-md-12" v-if="msgAlterada" >
          <div
            class="card"
            style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
            v-if="msg==1"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
          </div>
          <div
            class="card"
            style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
            v-if="msg==0"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
          </div>
          <div
            class="card"
            style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
            v-if="msg==2"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">Nome</label>
            <input
              type="text"
              id="nome"
              name="nome"
              placeholder="Nome"
              maxlength="200"
              class="form-control"
              v-model="permissao.nome"
              :style="styleNome"
            />
            <label
              class="control-label"
              v-if="styleNome!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
          </div>
        </div>
        
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="sel1">Tipo:</label>
            <select class="form-control" id="tipo" name="tipo" v-model="permissao.tipo"
            >
                <option value="0" disabled>-- Escolher Tipo de Usuario --</option>
                <option v-for="t in tiposUsuario" :key="t.id" :value="t.id" >{{t.nome}}</option>
              </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div style="background-color: rgb(255 255 255);border-radius: 5px;padding: 12px;">
            <label><b>Habilitar</b></label>
            <div class="row">
               <div class="col-md-1">
                  <label>Manifestação</label>
                  <switch-button v-model="permissao.h_manifestacao" color="#253DB9" :meuid="0" modulo="permissao" funcao="manifestacaoEditar"></switch-button>
               </div>
               <div class="col-md-1">
                  <label>Cidadão</label>
                  <switch-button v-model="permissao.h_cidadao" color="#253DB9" :meuid="0" modulo="permissao" funcao="cidadaoEditar"></switch-button>
               </div>
               <div class="col-md-2" v-if="permissao.tipo == 1">
                  <label>Unidade Organizacional</label>
                  <switch-button v-model="permissao.hab_mod_departamento" color="#253DB9" :meuid="0" modulo="permissao" funcao="departamentoCadastro"></switch-button>
               </div>
               <!--<div class="col-md-1">
                  <label>Logs</label>
                  <switch-button v-model="permissao.hab_log" color="#253DB9" :meuid="0" modulo="permissao" funcao="editorCadastro"></switch-button>
               </div>-->
            </div>
          </div>
        </div>  
      </div> 

      <!--<div class="row" >
        <div class="col-md-12">
          <div style="background-color: rgb(255 255 255);border-radius: 5px;padding: 12px;margin-top:20px;">
            <label><b>Escolher Departamentos ligados a essa Permissão</b></label>
            <div class="checkbox" v-for="v in secretarias" :key="v.id">
                <label><input type="checkbox" :value="v" v-model="departamentoEscolhidos.nome"> {{v.secretaria}}</label>
            </div>
          </div>
        </div>

      </div>-->

      <div class="row"  style="margin-top:20px;">
        <div class="col-md-12">
          <label>Ativar</label>
          <switch-button v-model="permissao.status" color="#253DB9" :meuid="0" modulo="permissao" funcao="exibirCadastro"></switch-button> 
        </div>
      </div>
      <div class="row">
        <div class="text-center" style="margin-left:15px;margin-top:20px;margin-bottom:20px;">
          <button
            type="button"
            class="btn btn-primary btn-fill float-left"
            @click.prevent="editar"
          >Editar</button>
          <button class="btn btn-danger" @click="retornar()" style="margin-left: 8px;">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/usuarioController.js";
import SwitchButton from 'src/components/switch.vue'

export default {
  name: "my-component",
  components: {
    VueGoodTable,
    SwitchButton
  },
  props: {
    row: {
      require: true,
    },
  },
  data() {
    return {
      permissao: {
        nome: null,
        tipo:0,
        h_manifestacao:false,
        h_cidadao:false,
        hab_mod_departamento:false,
        hab_log: false,
        departamentos: null,
        status:true,
        h:{
          manifesto:0,
          cidadao:0,
          mod_departamento:0,
          log:0,
        }
      },
      secretarias: null,
      tiposUsuario: [],
      users: {
        admin: null,
        admin_sistema: null,
      },
      departamentoEscolhidos:{
        nome: []
      },
      msgAlterada: null,
      msg: null,
      msgAlterada_senha: null,
      msg_senha: null,
      styleNome: "",
      styleEmail: "",
      styleSenha: "",
      emailUsado: null,
      emailverify: 0,
      senhaverify: 0,
      verify_email: false,
      verify_senha: false,
    };
  },
  methods: {
    retornar() {
      this.$router.push({ name: "permissao" });
    },
    async editar() {
      try {
        this.styleNome = "";

        if(this.permissao.tipo != 1){
          this.permissao.hab_log = false;
        }
      
        if (this.permissao.nome == null || this.permissao.nome =='') {
          this.styleNome = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Nome está Vazio!";
          this.msg = 0;
          return false;
        }
        
        if(this.permissao.h_manifestacao == true){
           this.permissao.h.manifesto = 1; 
        }else{
           this.permissao.h.manifesto = 0; 
        }
        
        if(this.permissao.h_cidadao == true){
           this.permissao.h.cidadao = 1; 
        }else{
           this.permissao.h.cidadao=0; 
        }
        
        if(this.permissao.hab_mod_departamento == true){
           this.permissao.h.mod_departamento=1; 
        }else{
           this.permissao.h.mod_departamento=0; 
        }

        if(this.permissao.hab_log == true){
           this.permissao.h.log=1; 
        }else{
           this.permissao.h.log=0; 
        }
          
        let departEscolhidos = [];
          
        var index = 0;
         
        /*this.departamentoEscolhidos.nome.forEach(element => {
            departEscolhidos[index] = element.id; 
            index++;
        });
 
        this.permissao.departamentos = departEscolhidos.toString(); */

        if(this.permissao.tipo == 2){
          this.permissao.h.mod_departamento=0; 
        }

        let data;
        if(this.permissao.tipo){
          data = await this.$permissaoEditar(this.permissao,this.row.id);
        }else{
          this.msgAlterada = "É necessario informar o tipo de Usuario desse Grupo!";
          this.msg = 0;
          return false;
        }
          if (data.msg == "Problemas na validacão!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            return false;
          }
          
          if(data.msg == "Editado com Sucesso!"){
            this.msgAlterada= "Editado com Sucesso!"
            this.msg = 1;
            setTimeout( () => this.$router.push({ path: '/sistema/permissao'}), 150); 
          }
        
        
      } catch (e) {
        //console.log(e.response.data);
        this.msgAlterada = e.response.data.msg;
        this.msg = 0;
        return false;
      }
    },
    async buscarSecretarias($dep) {
      try {
        let data = await this.$secretaria();
        this.secretarias = data.data;    
        for (let index = 0; index <= this.secretarias.length; index++) {
          for (let i = 0; i <= $dep.length; i++) {
            if(this.secretarias[index]['id'] == $dep[i]){
              let param = {
                id: $dep[i],
                secretaria: this.secretarias[index]['secretaria']
              };
              this.departamentoEscolhidos.nome.push(param);
            }
          } 
        }

      } catch (e) {
        //console.log(e);
      }
    },
    async buscarTipoUsuario() {
      try {
        let data = await this.$listarTiposUsuario();
        this.tiposUsuario = data.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
  async beforeMount() {
    try {
      if (this.row == null) {
        this.$router.push({ name: "permissao" });
      }else{
        await this.buscarTipoUsuario();
        
        this.users.admin = store.admin;
        this.users.admin_sistema = store.admin_sistema;
        
        this.permissao.tipo = this.row.tipo;
        this.permissao.nome = this.row.nome;
        this.permissao.h_manifestacao = (this.row.hab_manifestacao) ? this.row.hab_manifestacao = true : this.row.hab_manifestacao = false;
        this.permissao.h_cidadao = (this.row.hab_cidadao) ? this.row.hab_cidadao = true : this.row.hab_cidadao = false;

        this.permissao.hab_mod_departamento = (this.row.hab_mod_departamento) ? this.row.hab_mod_departamento = true : this.row.hab_mod_departamento = false;
        this.permissao.hab_editor = (this.row.hab_editor) ? this.row.hab_editor = true : this.row.hab_editor = false;
        this.permissao.status = (this.row.status) ? this.row.status=true : this.row.status=false;

        let stringDep = this.row.hab_departamentos;
        let resultado = stringDep.split(",");
        
        this.buscarSecretarias(resultado);
        
      }

    } catch (e) {}
  },
};
</script>

